<div class="ssp-container">

  <p-tree
    [value]="nodes"
    scrollHeight="320px"
    [loading]="loading && nodes.length === 0"
    selectionMode="single"
    [(selection)]="selectedNode"
    (onNodeExpand)="onNodeExpand($event)"
  >
    <ng-template let-node pTemplate="default">
      {{ node.label }}
      <p-progressSpinner
        *ngIf="node.loading"
        styleClass="ssp-node-spinner"
        strokeWidth="6"
      ></p-progressSpinner>
    </ng-template>
    <ng-template let-node pTemplate="loadmore">
      <button type="button" class="ssp-load-more-btn" (click)="onLoadMore($event, node)">More...</button>
    </ng-template>
    <ng-template let-node pTemplate="loadingmore">
      <p-progressSpinner styleClass="ssp-node-spinner" strokeWidth="6"></p-progressSpinner>
    </ng-template>
  </p-tree>

  <div class="ssp-actions">
    <button pButton label="Cancel" class="p-button-text p-button-sm" (click)="onCancel()"></button>
    <button
      pButton
      label="Choose"
      icon="pi pi-check"
      class="p-button-sm"
      [disabled]="!isSelectableFile(selectedNode)"
      (click)="onChoose()"
    ></button>
  </div>

</div>
